import { useLocalObservable } from 'mobx-react-lite';

import { Call } from '@gem/call/CallStore/Call';
import { Member } from '@gem/call/CallStore/Member/Member';
import { MemberDevice } from '@gem/call/CallStore/Member/MemberDevice';
import { useCallContext } from '@gem/call/CallView/CallView.context';
import { ParticipantsControlType } from '@gem/call/Model/callModel.types';

interface IMemberListPresenter {
  call: Call;
  memberDevices: MemberDevice[];
  keyExtractor(member: Member): string;
}

export const useMemberListPresenter = (): IMemberListPresenter => {
  const context = useCallContext();

  const presenter = useLocalObservable<IMemberListPresenter>(() => ({
    get call(): Call {
      return context.call;
    },

    get memberDevices(): MemberDevice[] {
      if (
        presenter.call.uiFeatures.participantsControlType === ParticipantsControlType.TotalNumber
      ) {
        return presenter.call.members.memberDevicesOnCallList || [];
      }
      return presenter.call.members.memberDevicesList || [];
    },

    keyExtractor(member: Member): string {
      return member.userId;
    },
  }));

  return presenter;
};
